import React, { useEffect, useState } from "react";
import {
    UploadingInput,
    BackNextButton,
    Input,
    Button,
    Modal, LoadingIcon
} from "../../../../../common";
import "react-datepicker/dist/react-datepicker.css";
import { ReactComponent as Close } from "../../../../../../assets/icons/close-circle.svg";
import { useSelector } from "react-redux";
import LockedImage from '../../../../../../assets/icons/locked.png'
import { ReactComponent as Warning } from "../../../../../../assets/icons/Warning.svg";
import Papa from 'papaparse';
import DownloadButton from "../../../../../common/DownloadButton";
import csvFile from '../../../../../../assets/files/financial_document_sample.csv'
import ShowHeadersComp from "./ShowHeadersComp";
import { getCurrentYear, isDateGreaterThanProvidedYearsAgo } from "../../../../../../utils/Helper";
import FinancialCharts from "../../../../../common/FinancialCharts";
import { useGetCompanyFinanceChartDataMutation, useUploadFinanceDocumentMutation } from "../../../../../../store/Company/companyApiSlice";
import { CommonToast } from "../../../../../common/Toast";

export const FinancialDocuments = ({ onPrev, onNext, onSkip, onlyGraph = false, resData, fetchGraphData, setFetchGraphData = () => false, showWarning
}) => {
    const filename = "sampleFinancialDocument.csv";
    const { currentEditingCompany } = useSelector((state) => state.company);
    const [previewImage, setPreviewImage] = useState("");
    const [fileuploading, setfileuploading] = useState(false);
    const { token, userInfo } = useSelector((state) => state.auth);
    const [progress, setProgress] = useState(0);
    const [uploadedFile, setUploadedFile] = useState("");
    const [financialDetails, setFinancialData] = useState("");
    const [isOpen, setIsOpen] = useState(false);
    const [headerObject, setHeaderObject] = useState({});
    const [csvData, setCsvData] = useState({})
    const [clear, setClear] = useState(false);
    const [buttonDisabled, setButtonDisabled] = useState(true);
    const [showUpload, setShowUpload] = useState(false);
    const [error, setError] = useState([])
    const requiredCSVHeaders = [
        "year",
        "total_revenue",
        "net_earnings",
        "cost_of_goods_serv_sold",
        "earnings_before_interest_tax",
        "interest_expenses",
        "total_equity",
        "total_assets",
        "total_current_assets",
        "inventories",
        "total_current_liabilities",
        "trade_receivables",
        "trade_payables",
        "short_term_debt",
        "long_term_debt",
        "current_long_term_debt_portion",
        "net_cash_flow_operations",
        "net_cash_flow_investment"
    ];
    const [matchedHeaders, setMatchedHeaders] = useState([]);
    const [csvHeaders, setCsvHeaders] = useState([]);
    const [showUploadInput, setShowUploadInput] = useState(false);
    const [misMatchedHeaders, setMisMatchedHeaders] = useState([]);
    const [stringError, setStringError] = useState("");
    const [uploadFinanceDocument] = useUploadFinanceDocumentMutation();
    const handlePrev = () => {
        onPrev();
    }
    const result = currentEditingCompany?.date_of_establishment ? isDateGreaterThanProvidedYearsAgo(currentEditingCompany?.date_of_establishment, 3) : false;
    const renderPreview = () => {
        if (uploadedFile.type.includes("image")) {
            return <img src={previewImage} alt="trade" className="w-18" />;
        } else if (uploadedFile.type === "application/pdf" || uploadedFile.type === "text/csv") {
            return (
                <embed
                    src={`${URL.createObjectURL(uploadedFile)}#page=1`}
                    type={uploadedFile.type}
                    width="100%"
                    height="500px"
                />
            );
        } else {
            return <p>Unsupported file type</p>;
        }
    };
    const renderPreview1 = (url) => {
        if (url != undefined) {
            if (!url.includes(".pdf")) {
                return <img src={url} alt="trade" className="w-18" />;
            } else {
                return (
                    <embed
                        src={url}
                        type="application/pdf"
                        width="100%"
                        height="500px"
                    />
                );
            }
        }

    };
    const handleFileSelect = async (file) => {
        setUploadedFile(file, () => { });
        setProgress(100);
        if (file && file.type.match("image.*")) {
            const reader = new FileReader();

            reader.onload = (e) => {
                setPreviewImage(e.target.result);
            };

            reader.readAsDataURL(file);
        } else {
            setPreviewImage(null);
        }
    };
    useEffect(() => {
        misMatchedHeaders?.length === 0 && matchedHeaders?.length === 18 ? setButtonDisabled(false) : setButtonDisabled(true);
    }, [misMatchedHeaders])
    useEffect(() => {
        if (uploadedFile) {
            Papa.parse(uploadedFile, {
                header: true,
                transformHeader: header => header.trim(),
                dynamicTyping: true,
                skipEmptyLines: true,
                complete: (result) => {
                    const headersInCSV = Object.keys(result?.data?.length > 0 ? result?.data[0] : []);
                    //seting all headers from the csv file
                    setCsvHeaders(headersInCSV.slice(0, headersInCSV.length));
                    // Filter out headers that are not in the required list
                    // const matchingHeaders = requiredCSVHeaders.filter(requiredHeader => headersInCSV?.some(header => header === requiredHeader));
                    const { matchedHeaders, mismatchedHeaders } = requiredCSVHeaders.reduce(
                        (result, requiredHeader) => {
                            if (headersInCSV.some((header) => header === requiredHeader)) {
                                result.matchedHeaders.push(requiredHeader);
                            } else if (requiredHeader !== '__parsed_extra') {
                                result.mismatchedHeaders.push(requiredHeader);
                            }
                            return result;
                        },
                        { matchedHeaders: [], mismatchedHeaders: [] }
                    );
                    setMatchedHeaders(matchedHeaders);
                    setMisMatchedHeaders(mismatchedHeaders);
                    const arrayOfObjects = result?.data.map(row => {
                        // Filter out headers that are not in the required list
                        const filteredRow = Object.keys(row)
                            .reduce((obj, key) => {
                                if (obj != {}) {
                                    obj[key] = row[key];
                                    return obj;
                                }
                            }, {});
                        return filteredRow;
                    });
                    setCsvData(arrayOfObjects);
                    mismatchedHeaders?.length > 0 && setIsOpen(true);
                },
            });

        }
        else {
            setIsOpen(false);
        }
    }, [uploadedFile]);
    function findDuplicateValues(obj) {
        const valueCount = {};
        const duplicateKeys = [];

        for (const key in obj) {
            if (obj.hasOwnProperty(key)) {
                const value = obj[key];
                // Check if the value has been encountered before
                if (valueCount[value]) {
                    duplicateKeys.push(key, valueCount[value]);
                } else {
                    // Store the key if the value is encountered for the first time
                    valueCount[value] = key;
                }
            }
        }

        return duplicateKeys;
    }

    function findKeyByValue(obj, targetValue) {
        for (const key in obj) {
            if (obj.hasOwnProperty(key) && obj[key] === targetValue) {
                return key;
            }
        }
        return null; // Return null if the value is not found
    }

    function findDuplicateYears(data) {
        const duplicateYears = [];
        const seenYears = new Set();

        for (const item of data) {
            if (seenYears.has(item.year)) {
                duplicateYears.push(item.year);
            } else {
                seenYears.add(item.year);
            }
        }

        return duplicateYears;
    }

    const handleContinue = async (runQuery = true) => {
        try {
            const dublicateKeys = findDuplicateValues(headerMapping);
            const obj = headerMapping;
            if (dublicateKeys?.length > 0) {
                setError(dublicateKeys)
            } else {
                const mappedData = csvData.map(item => {
                    const newObj = {};
                    for (const key in item) {
                        const findKeyByVal = findKeyByValue(obj, key)
                        if (item.hasOwnProperty(key) && findKeyByVal) {
                            newObj[findKeyByVal] = item[key];
                        }
                    }
                    return newObj;
                });
                const duplicateYear = findDuplicateYears(mappedData)
                if (duplicateYear?.length > 0) {
                    setStringError("Duplicate year detected")
                } else {
                    setStringError("")
                    let maxYear;
                    if (resData?.max_year !== 0) {
                        maxYear = resData?.max_year;
                    } else {
                        const currentMaxYear = getCurrentYear();
                        mappedData.forEach(item => {
                            if (item.year === currentMaxYear || item.year === currentMaxYear - 1) {
                                if (maxYear) {
                                    maxYear = Math.max(maxYear, item.year);
                                } else {
                                    maxYear = item.year;
                                }
                            }
                        });
                    }
                    maxYear ? setStringError("") : setStringError("Invalid Data");
                    if (runQuery) {
                        const minYear = maxYear - 5;
                        const validatedData = mappedData.filter(item => (item.year === maxYear || item.year === maxYear - 1 || item.year === maxYear - 2));
                        const validatedOlderData = mappedData.filter(item => (item.year <= maxYear - 5));
                        const filteredData = mappedData.filter(item => item.year <= maxYear && item.year > minYear);
                        if (filteredData.length === mappedData.length && validatedData?.length === 3 && validatedOlderData?.length === 0) {
                            const res = await uploadFinanceDocument({ data: filteredData, token: token, company_id: currentEditingCompany?.companyID }).unwrap();
                            if (res.statusCode === 201) {
                                CommonToast.success(res.message ?? "Something Went wrong!")
                                setIsOpen(false);
                                onNext(0, "MOA", "Upload KK");
                            } else {
                                CommonToast.error(res.message ?? "Something Went wrong!")
                            }
                        } else {
                            setStringError(resData?.max_year ? `Please note that we accept financial data for the last 5 years only. Since you've already uploaded data for the year ${maxYear}, So please remove data for the years ${minYear} or earlier.` : "To ensure accuracy and consistency in analysis, we require a minimum of three consecutive years' and a maximum of five years' data. In cases where data for the current year is unavailable, we will utilize the data from the previous year along with the data from the two preceding years to maintain continuity in our analysis.");
                        }
                    }
                }
            }
        } catch (error) {
            CommonToast.error(error ?? "Something went wrong!")
        }
    }
    const handleSubmit = async (e) => {
        e.preventDefault();
        handleContinue();
    };

    useEffect(() => {
        if (stringError !== "" || error.length > 0) {
            setIsOpen(true);
        }
    }, [stringError, error])
    function convertFileSize(size) {
        if (size < 1024) {
            return size + " B";
        } else if (size < 1024 * 1024) {
            return (size / 1024).toFixed(2) + " KB";
        } else {
            return (size / (1024 * 1024)).toFixed(2) + " MB";
        }
    }

    const headerMapping = {};

    requiredCSVHeaders?.forEach(key => {
        const csvHeaderValue = csvHeaders.find(header => header === key);
        headerMapping[key] = key === csvHeaderValue ? csvHeaderValue : "";
    });

    const modalHandle = (e) => {
        e.preventDefault();
        setClear(!clear); setUploadedFile(""); setPreviewImage(null); setProgress(0);setStringError("");setError([])
        setIsOpen(false);
    };
    return (
        <div className="mt-5 w-full md:max-w-[95%] lg:max-w-[90%]">
            <h3 className="text-f20 font-semibold text-secondarytwo text-left mb-2 flex">
                {onlyGraph ? 'Financial Graphs' : 'Financial Document'}
            </h3>
            {!onlyGraph ? <div className={`relative ${!result && "bg-gradient-to-r from-[#FF8D75]/10 to-[#6D1A08]/10 rounded-2 shadow-none p-3 mb-3"}`}>
                <div className={` ${!result && "blur"}`}>
                    <div className={`w-full flex justify-end gap-2 mb-4`}>
                        {/* {!showUploadInput && <Button onClick={() => { setShowUploadInput(!showUploadInput) }} classes={`relative group w-[210px] py-3 px-1 text-center text-sm font-semibold text-white bg-primary rounded-md  inline-flex items-center justify-center gap-4`}>Upload More Data</Button>} */}
                        <Button
                            classes={`relative group w-[210px] py-3 px-1 text-center text-sm font-semibold text-white bg-primary rounded-md  inline-flex items-center justify-center gap-4 ${!result && "cursor-not-allowed"}`}
                            disable={!result}
                        >
                            <span className="relative">
                                <DownloadButton
                                    link={csvFile}
                                    filename={filename}
                                    buttonName="Download CSV Template"
                                    disable={!result}
                                    classes={`text-white text-[14px] ${!result && "cursor-not-allowed"}`}
                                />
                            </span>
                        </Button>
                    </div>
                    {showWarning && <div className='w-fit flex items-center p-1 text-warning border border-warning rounded-[5px] text-[10px] gap-2 mb-4'><Warning height='14px' /><p>The existing data will be superseded by the information contained in the re-uploaded sheet.</p></div>}
                    {<div >
                        <form
                            className={`relative border border-slate rounded-lg p-8 mb-6`}
                            onSubmit={handleSubmit}
                        >
                            <label
                                htmlFor=""
                                className="block mb-1 text-primary text-f14 font-semibold text-left"
                            >
                                Upload Income Statement CSV File
                            </label>
                            {fileuploading ? <LoadingIcon /> : !uploadedFile && <UploadingInput onFileSelect={result ? handleFileSelect : null} isUploading={true} format={".csv"} disable={!result} clear={clear} />}

                            {uploadedFile && (
                                <div className="bg-slate mt-2 p-3 rounded-md relative ">
                                    <div className="flex gap-3">
                                        <div
                                            className={`flex-auto w-16 ${uploadedFile.type === "application/pdf" ? "h-20" : "h-14"
                                                } overflow-hidden`}
                                        >
                                            {renderPreview()}
                                        </div>
                                        <div className="flex flex-col items-start justify-center text-secondarytwo">
                                            <p className="text-f14">{uploadedFile.name}</p>
                                            <div>
                                                <span className="text-f12 text-secondary">
                                                    {convertFileSize(uploadedFile.size)}
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                    {true && (
                                        <div className="flex gap-3 items-center justify-start mt-3">
                                            <div className="bg-white h-2 rounded-full overflow-hidden  relative w-full">
                                                <div
                                                    className="bg-primary h-full transition-all"
                                                    style={{ width: `${progress}%` }}
                                                ></div>
                                            </div>
                                            <span className="">{progress}%</span>
                                        </div>
                                    )}

                                    {uploadedFile && (
                                        <button
                                            className="absolute right-3 top-3"
                                            onClick={() => { setClear(!clear); setUploadedFile(""); setPreviewImage(null); setProgress(0) }}
                                        >
                                            <Close />
                                        </button>
                                    )}
                                </div>
                            )}
                        </form>
                        {isOpen && <Modal modalHandle={modalHandle}>
                            <div className="text-left flex flex-col pt-4 px-2">
                                <h3 className="text-f20 font-semibold">
                                    {stringError !== "" ? "Invalid Data" : 'Invalid CSV Headers'}
                                </h3>
                                {stringError !== "" ? <p className="text-secondary pb-4 text-f16 w-[300px]">{stringError}</p> : <p className="text-secondary pb-4 text-f16 w-[300px]">
                                    <p>{error?.length > 0 ? 'We found dublicates headers' : 'Below headers are missing in your csv.'}</p>
                                    <ul className="list-disc pl-8">
                                        {error?.length > 0 ? error : misMatchedHeaders?.map((header, index) => (
                                            <li key={index}>{header}</li>
                                        ))}
                                    </ul>
                                </p>}
                                <div className="flex text-secondary pt-4 w-full gap-4">
                                    <Button
                                        onClick={modalHandle}
                                        classes="bg-primary px-4 py-2 text-white text-f14 rounded w-full"
                                    >
                                        Close
                                    </Button>
                                </div>
                            </div>
                            {/* <ShowHeadersComp matchedHeaders={matchedHeaders} csvHeaders={csvHeaders} requiredCSVHeaders={requiredCSVHeaders} headerMapping={headerMapping} setHeaderObject={setHeaderObject} headerObject={headerObject} csvData={csvData} setIsOpen={setIsOpen} setButtonDisabled={setButtonDisabled} setFetchGraphData={setFetchGraphData} fetchGraphData={fetchGraphData} /> */}
                        </Modal>}
                    </div>}

                </div>
                {!result && <div className="text-center flex flex-col items-center absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 shadow-inner-2xl rounded-lg p-4 w-1/3">
                    <img
                        src={LockedImage}
                        className="w-1/4 mx-auto mb-3"
                        alt="Credit Notice"
                    />
                    <h3 className="text-secondarytwo text-left text-f20 font-semibold mb-2 text-center">
                        Uploading CSV file is not available
                    </h3>
                    <p className="text-secondary text-f14 mb-3 w-3/4">
                        {currentEditingCompany?.registered_company_name} is less than 3 years in business. Hence you do not have this option active.
                    </p>
                    <div className="flex justify-between text-secondary items-center"></div>
                </div>}
            </div> :
                <FinancialCharts edit={true} setShowUploadInput={setShowUploadInput} fetchGraphData={fetchGraphData} resData={resData} />
            }
            <BackNextButton
                onPrev={handlePrev}
                onNext={handleSubmit}
                onSkip={() => onSkip(0, "MOA", "Upload KK")}
                isLoading={false}
                disable={!result || buttonDisabled}
            />
        </div>
    );
};